import { Box, Flex, Image } from "@chakra-ui/react";
import React from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import LazyLoad from "react-lazyload";

function Book({ setViewBook }) {
  const images = [];

  const importAll = (r) => {
    r.keys().forEach((key) => {
      const image = r(key);
      const number = parseInt(key.match(/(\d+)/)[0], 10);
      images.push({ number, image });
    });

    images.sort((a, b) => a.number - b.number);
  };

  importAll(require.context("../assets/book/", false, /\.(png|jpe?g|svg)$/));
  console.log(images);

  return (
    <Box mt={"15px"}>
      <Box position={"sticky"} top={"10px"}>
        <Flex
          justifyContent={"flex-end"}
          alignSelf={"flex-end"}
          onClick={() => setViewBook(false)}
          m={"15px"}
        >
          <IoIosCloseCircleOutline fontSize={"40px"} color={"#fff"} />
        </Flex>
      </Box>
      {images.map((image, index) => (
        <LazyLoad key={index} height={200} offset={100} once>
          <Image my={"3px"} src={image.image} alt={`Image ${image.number}`} />
        </LazyLoad>
      ))}
    </Box>
  );
}

export default Book;
